import { Property } from '@app/trpc-api/models/Binders';
import { useMutation, useQueryClient } from 'react-query';
import { trpc } from '../../../../lib/trpc';
import { getPropertiesKeys } from './propertyQueries';

const publishProperties = async (properties: Property[]) => {
    const removeProperty = properties.map(async (property) => {
        return await trpc.BindersApi.publishProperty.query({ propertyId: property.id });
    });

    const deleteProperty = await Promise.all(removeProperty);

    return deleteProperty;
};

type Variables = {
    properties: Property[];
    projectId: number;
};

const usePublishProperties = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async (variables: Variables) => {
            await publishProperties(variables.properties);
        },
        {
            onSettled: () => {
                queryClient.invalidateQueries(getPropertiesKeys.lists());
            },
        },
    );
};

export default usePublishProperties;
